export default __webpack_public_path__ + "static/media/groundplan_d_63b.e7f1d28f.png";